import { render, staticRenderFns } from "./CurrencyConfiguration.vue?vue&type=template&id=08d5c917&scoped=true"
import script from "./CurrencyConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyConfiguration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CurrencyConfiguration.vue?vue&type=style&index=0&id=08d5c917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5c917",
  null
  
)

export default component.exports